<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'lgpdCrud'" crudName="Solicitações - LGPD" newText="Nova Solicitação" :table="table"
          :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true"
          :enableDelete="true" :enableView="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "lgpdTable",
      showMessageImport: false,
      lgpdCrud: {},
      pages: [],
      url: "",
      columns: ["id", "project_id", "name", "status", "actions"],
      tableData: ["id", "project_id", "name", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["name", "status", "project_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          status: "Status",
          project_id: "Sistema",
          actions: "Ações",
        },
        sortable: [],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 0,
              text: "Aguardando atendimento",
            },
            {
              id: 1,
              text: "Em atendimento",
            },
            {
              id: 2,
              text: "Finalizado",
            },
          ],
        },
        templates: {
          project_id: function (h, row, index) {
            return row.project.id ? row.project.name : "Não informado";
          },
          status: function (h, row, index) {
            switch (row.status) {
              case (0):
                return (<span class="badge badge-secondary">Aguardando atendimento</span>);
              case (1):
                return (<span class="badge badge-primary">Em atendimento</span>);
              case (2):
                return (<span class="badge badge-danger">Finalizado</span>);
            }

            // row.status
            //   ? (<span class="badge badge-primary">Ativo</span>)
            //   : (<span class="badge badge-secondary">Inativo</span>)
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          requestData.params.query = "";
          requestData.params.with = ["project"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "lgpds/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-users";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.usersCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        project_id: "project[name]",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>